import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'maskLast4' })
export class MaskLast4Pipe implements PipeTransform {
  transform(value: string | null): string {
    if (!value) return '';
    const digits = value.replace(/\D/g, '');
    const last4 = digits.slice(-4);
    const maskedLength = Math.max(0, digits.length - 4);
    const masked = '*'.repeat(maskedLength) + last4;
    return masked.replace(/(.{4})/g, '$1 ').trim();
  }
}
